import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../api.service';
import { Course } from '../course.model';
import { CourseVendor } from '../course-vendor.model';

@Component({
selector: 'app-landing-page-course-vendor',
templateUrl: './landing-page-course-vendor.component.html',
styleUrls: ['./landing-page-course-vendor.component.scss']
})
export class LandingPageCourseVendorComponent implements OnInit {
    @Input() course: Course;
    @Input() courseVendor: CourseVendor;
    
    isLoading: boolean = false;
    isLoaded: boolean = false;
    loadingError: string = '';
    errorMessage: string = '';
    display: boolean = false;

    constructor(
        private apiService: ApiService,
    ) { }

    ngOnInit(): void {
        this.get()
    }

    get() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.loadingError = '';

        this.apiService.getCourseVendor(this.course, this.courseVendor).subscribe(
            (data) => {
                this.courseVendor = new CourseVendor(data);
                this.isLoaded = true;
                this.isLoading = false;
            },
            (error) => {
                this.isLoaded = true;
                this.isLoading = false;
                this.loadingError = error;
            }
        );
    }


    open(url){
        window.open(url, "_blank");
    }

    openDocebo(){
        window.open(`/dashboard/lms/${this.courseVendor.docebo.id}`, "_blank");
    }

    openZoom(){
        console.log(`open zoom`)
        // window.open(`/dashboard/lms/${this.session.integrations.zoom.applicationId}`, "_blank");
    }

    get vendor(){
        return this.courseVendor.vendor;
    }
}
